import { createPortal } from "react-dom";
import { useEffect } from "react";
import { ExternalLink, X, Info } from "lucide-react";
import { OUTBOUND } from "@/data/static";

export default function OutboundModal({ open, onClose, deviceName, deviceBrand, mode = "marketplace" }) {
  useEffect(() => {
    if (!open) return;
    document.body.style.overflow = "hidden";
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  if (!open) return null;
  const links = mode === "pta" ? [OUTBOUND.ptaCalculator] : OUTBOUND.marketplaces(deviceName || "gaming phone", deviceBrand);
  const heading = mode === "pta" ? "Check PTA Tax (external)" : `Buy options for ${deviceName}`;

  return createPortal(
    <div
      data-testid="outbound-modal"
      className="fixed inset-0 z-[60] flex items-end sm:items-center justify-center bg-black/70 backdrop-blur-sm p-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md rounded-2xl border border-border bg-slateSurface p-6 shadow-2xl animate-fade-up"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-4 flex items-start justify-between">
          <h3 className="font-heading text-lg font-bold text-white">{heading}</h3>
          <button data-testid="outbound-close" onClick={onClose} className="text-slate-400 hover:text-white">
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="mb-4 flex gap-2 rounded-lg border border-cyber/30 bg-cyber/5 p-3 text-xs text-slate-300">
          <Info className="mt-0.5 h-4 w-4 shrink-0 text-cyber" />
          <p>
            These are <strong className="text-slate-100">external third-party links</strong>. We are not affiliated with
            these stores or the PTA and do not verify listings or prices. Inspect devices in person and confirm details
            independently before paying.
          </p>
        </div>

        <div className="space-y-2">
          {links.map((l) => (
            <a
              key={l.url}
              data-testid={`outbound-link-${l.label.replace(/\s+/g, "-").toLowerCase()}`}
              href={l.url}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="flex items-center justify-between rounded-lg border border-border bg-graphite px-4 py-3 text-sm font-medium text-white transition-all hover:border-neon/50 hover:bg-slateSurface"
            >
              {l.label}
              <ExternalLink className="h-4 w-4 text-neon" />
            </a>
          ))}
        </div>
      </div>
    </div>,
    document.body
  );
}
